import { ShieldCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { CERTIFICATIONS } from "../../data/siteData";

export const Certifications = () => (
  <section id="certifications" className="section bg-[#081C3A]" data-testid="certifications-section">
    <div className="container-custom">
      <SectionHeading
        eyebrow="Compliance & Accreditation"
        title="Fully Certified For Works At Height & Beyond"
        subtitle="Every Quanticom crew holds the tickets and accreditations required to deliver safe, compliant work nationwide."
        center
      />

      <div className="flex flex-wrap justify-center gap-5">
        {CERTIFICATIONS.map((cert, i) => (
          <Reveal key={cert} delay={i * 0.06}>
            <div
              className="group relative flex items-center gap-3 rounded-full pl-3 pr-6 py-3 bg-[#121826] border border-[#D4A017]/30 hover:border-[#D4A017] transition-all duration-300 hover:-translate-y-1"
              style={{ boxShadow: "0 0 0 rgba(212,160,23,0)" }}
              data-testid={`certification-${i}`}
            >
              <span className="w-10 h-10 rounded-full flex items-center justify-center bg-[#D4A017]/15 border border-[#D4A017]/40 group-hover:bg-[#D4A017] transition-colors">
                <ShieldCheck className="w-5 h-5 text-[#D4A017] group-hover:text-[#081C3A] transition-colors" />
              </span>
              <span className="font-semibold text-white text-sm tracking-wide">{cert}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
